module.exports = __webpack_public_path__ + "img/about3.7ec0cb59.png";